import { Box } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

export const BottomActionBar: FC<PropsWithChildren> = ({ children }) => {
  const [keyboardOffset, setKeyboardOffset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;

    if (!viewport) {
      return;
    }

    const updateKeyboardOffset = (): void => {
      const nextOffset = Math.max(
        0,
        window.innerHeight - viewport.height - viewport.offsetTop,
      );
      setKeyboardOffset(nextOffset);
    };

    updateKeyboardOffset();
    viewport.addEventListener('resize', updateKeyboardOffset);
    viewport.addEventListener('scroll', updateKeyboardOffset);
    window.addEventListener('resize', updateKeyboardOffset);

    return () => {
      viewport.removeEventListener('resize', updateKeyboardOffset);
      viewport.removeEventListener('scroll', updateKeyboardOffset);
      window.removeEventListener('resize', updateKeyboardOffset);
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        bottom: `${keyboardOffset}px`,
        boxShadow: 6,
        left: { sm: '264px', xs: '8px' },
        pb: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
        position: 'fixed',
        pt: 1,
        px: { md: 3, xs: 1 },
        right: { md: '24px', xs: '8px' },
        transition: 'bottom 120ms ease-out',
        zIndex: 1000,
      }}
    >
      {children}
    </Box>
  );
};
